module.exports = __webpack_public_path__ + "img/tv-simulation.66984d00.jpg";